import { useCallback, useEffect, useRef, useState } from "react";
import { metaGrowthApi, MetaGrowthDashboardDto } from "@/features/meta-growth/api/meta-growth.api";
import { OrdersAnalyticsFilters } from "@/features/orders-analytics/types/orders-analytics.types";

export function useMetaGrowthData(filters: OrdersAnalyticsFilters) {
    const [data, setData] = useState<MetaGrowthDashboardDto | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);
    const [reloadKey, setReloadKey] = useState(0);
    const previousFiltersRef = useRef<OrdersAnalyticsFilters | null>(null);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);

        if (previousFiltersRef.current !== filters) {
            setData(null);
            setError(null);
            previousFiltersRef.current = filters;
        }

        metaGrowthApi
            .fetchDashboard(filters)
            .then((dto) => {
                if (!cancelled) {
                    setData(dto);
                    setError(null);
                }
            })
            .catch((fetchError: unknown) => {
                if (!cancelled) {
                    setData(null);
                    setError(
                        fetchError instanceof Error
                            ? fetchError
                            : new Error("Failed to load Meta Growth dashboard")
                    );
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [filters, reloadKey]);

    const refresh = useCallback(() => {
        setReloadKey((key) => key + 1);
    }, []);

    return { data, loading, error, refresh };
}
